import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  output,
  OutputEmitterRef,
} from '@angular/core';

@Component({
  selector: 'edit-tool-bar',
  imports: [CommonModule],
  templateUrl: './edit-tool-bar.component.html',
  styleUrl: './edit-tool-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditToolBarComponent {
  public changeSelectedSidebarIndex: OutputEmitterRef<number> = output();

  public selectedSidebarIndex: number = 0;

  constructor(private cd: ChangeDetectorRef) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onSelectSidebar(index: number): void {
    this.selectedSidebarIndex = index;
    this.changeSelectedSidebarIndex.emit(this.selectedSidebarIndex);
    this.cd.markForCheck();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------
}
